var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "VButton",
    {
      staticClass: "manual-like",
      attrs: { round: "" },
      on: { click: _vm.like },
    },
    [
      _c("div", { class: { like: _vm.isLike }, attrs: { id: "text" } }, [
        _vm._v(
          "正在点赞: " +
            _vm._s(_vm.curLikeCnt) +
            " / " +
            _vm._s(_vm.totalLikeCnt)
        ),
      ]),
      _vm._v(" "),
      _c("VIcon", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLike,
            expression: "!isLike",
          },
        ],
        attrs: { colored: "", icon: "like", size: 20 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }